var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMachineManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeWidth: 12,
    d: "M157 93c0-36.45-29.549-63-66-63-36.45 0-66 29.55-66 66 0 36.451 29.55 66 66 66h6.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C71B8",
    d: "M122.882 97.88c.111-1.254 0-3.76 0-3.76L129 85.977a38.033 38.033 0 0 0-3.759-9.066l-10.061-1.437a67.667 67.667 0 0 0-2.653-2.653L111.09 62.76a37.66 37.66 0 0 0-9.066-3.76l-8.145 6.118a21.247 21.247 0 0 0-3.758 0L81.976 59a38.029 38.029 0 0 0-9.066 3.759l-1.437 10.06a67.609 67.609 0 0 0-2.653 2.654L58.759 76.91A37.66 37.66 0 0 0 55 85.976l6.117 8.145c-.073 1.253 0 3.758 0 3.758L55 106.024a38.045 38.045 0 0 0 3.759 9.066l10.06 1.437c.86.933 1.745 1.818 2.654 2.653l1.437 10.061A37.655 37.655 0 0 0 81.976 133l8.145-6.118c1.25.111 2.508.111 3.758 0l8.145 6.118a38.049 38.049 0 0 0 9.066-3.759l1.437-10.061c.921-.847 2.653-2.653 2.653-2.653l10.061-1.437a37.656 37.656 0 0 0 3.759-9.066l-6.118-8.145ZM92 113.688a17.687 17.687 0 0 1-17.35-21.14A17.689 17.689 0 1 1 92 113.689Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M92 114c9.941 0 18-8.059 18-18s-8.059-18-18-18-18 8.059-18 18 8.059 18 18 18Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M112.527 72.82a45.16 45.16 0 0 1 2.653 2.653l10.061 1.437A38.033 38.033 0 0 1 129 85.976l-6.118 8.145s.111 2.505 0 3.758l6.118 8.145a37.656 37.656 0 0 1-3.759 9.066l-10.061 1.437s-1.732 1.806-2.653 2.653l-1.437 10.061a38.049 38.049 0 0 1-9.066 3.759l-8.145-6.118c-1.25.111-2.508.111-3.758 0L81.976 133a37.655 37.655 0 0 1-9.066-3.759l-1.437-10.061a67.667 67.667 0 0 1-2.653-2.653l-10.061-1.437A38.045 38.045 0 0 1 55 106.024l6.117-8.145s-.073-2.505 0-3.758L55 85.976a37.66 37.66 0 0 1 3.759-9.066l10.06-1.437a67.609 67.609 0 0 1 2.654-2.653l1.437-10.061A38.029 38.029 0 0 1 81.976 59l8.145 6.118a21.247 21.247 0 0 1 3.758 0L102.024 59a37.66 37.66 0 0 1 9.066 3.759l1.437 10.06ZM164 133h-17m17 9h-17m29 31.708v-50.416a2.285 2.285 0 0 0-2.278-2.292h-36.444a2.285 2.285 0 0 0-2.278 2.292v50.416a2.285 2.285 0 0 0 2.278 2.292h36.444a2.285 2.285 0 0 0 2.278-2.292Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C71B8",
    fillOpacity: 0.2,
    stroke: "#1C71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M176 173.708v-50.416a2.285 2.285 0 0 0-2.278-2.292h-36.444a2.285 2.285 0 0 0-2.278 2.292v50.416a2.285 2.285 0 0 0 2.278 2.292h36.444a2.285 2.285 0 0 0 2.278-2.292Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C71B8",
    d: "M154.5 167a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineManagement);
export default __webpack_public_path__ + "static/media/MachineManagement.a7cccd13060b790a5c80bcc9ae518149.svg";
export { ForwardRef as ReactComponent };